import { INJECT_TAG } from "../metadata_keys";

import { injectBase } from "./inject_base";

export const inject = injectBase(INJECT_TAG);
//# sourceMappingURL=inject.js.map
